/* eslint-disable react/jsx-filename-extension */
import React, { useRef } from 'react';
import inRange from 'lodash/inRange';
import PropTypes from 'prop-types';
import {
  FormLabel,
} from '@one-thd/sui-atomic-components';
import {
  InputNumber,
  ErrorMessage,
} from './styles';

function InputMeasure(props) {
  const {
    errorText,
    inputName,
    placeholder,
    showError,
    forwardedRef,
    label,
    id,
    value,
  } = props;

  const validateKeyPress = (inputValue) => {
    const numbers = /^[0-9]{1,2}(\.\d{0,2})?$/;

    return numbers.test(inputValue);
  };

  const maxiChange = (newValue) => {
    const minimumValue = 1;
    const maximumValue = 99.99;
    const value = validateKeyPress(newValue);

    return inRange(value, minimumValue, maximumValue);
  };

  const handleInput = (event) => {
    const numbers = /[0-9.]/;
    const existingValue = forwardedRef.current[inputName].value;
    if (existingValue === '' && event.key === '0') {
      event.preventDefault();
      return;
    }
    const { selectionStart, selectionEnd } = event.target;
    const proposedInput = selectionStart === selectionEnd
      ? [
        existingValue.slice(0, selectionStart),
        event.key,
        existingValue.slice(selectionStart),
      ]
      : [
        existingValue.slice(0, selectionStart),
        event.key,
        existingValue.slice(selectionEnd),
      ];
    const isMax = maxiChange(proposedInput.join(''));

    if (!numbers.test(event.key) || !isMax) {
      event.preventDefault();
    }
  };

  const handlePaste = (event) => {
    const pastedText = event.clipboardData.getData('text');
    const existingValue = forwardedRef.current[inputName].value;
    const proposedInput = existingValue.concat(pastedText);
    if (!maxiChange(proposedInput)) {
      event.preventDefault();
    }
  };

  const customRef = (el) => {
    if (el) {
      forwardedRef.current[inputName] = el;
    }
  };

  return (
    <>
      <FormLabel htmlFor={id}>{label}</FormLabel>
      <InputNumber
        id={id}
        data-testid={id}
        ref={customRef}
        type="text"
        inputMode="decimal"
        min="0"
        max="99"
        minLength="1"
        maxLength="5"
        name={inputName}
        placeholder={placeholder}
        defaultValue={value}
        onPaste={(event) => handlePaste(event)}
        onKeyPress={(event) => handleInput(event)}
        showError={showError}
      />
      <ErrorMessage showError={showError}>{errorText}</ErrorMessage>
    </>
  );
}

InputMeasure.propTypes = {
  errorText: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  inputName: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  showError: PropTypes.bool.isRequired,
  id: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  forwardedRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({})
  ]),
};

InputMeasure.defaultProps = {
  id: 'id',
  value: undefined,
  forwardedRef: {},
};

export default InputMeasure;
